import i18n from 'constants/translation/i18n';

const testingAreas = (t?: any) => {
  const entries = [
    {
      area: 'controlsAttestation',
      title: t ? t('CONTROL_ATTESTATION') : i18n.t('CONTROL_ATTESTATION'),
      href: '/controlsAndRiskAllocation/controlAttestation'
    },
    {
      area: 'controlsTestingDesign',
      title: t ? t('CONTROLS_TEST_DESIGN') : i18n.t('CONTROLS_TEST_DESIGN'),
      href: '/controlsAndRiskAllocation/controlsTestingDesignEffectiveness'
    },
    {
      area: 'controlsTesting',
      title: t ? t('CONTROLS_TEST') : i18n.t('CONTROLS_TEST'),
      href: '/controlsAndRiskAllocation/controlsTesting'
    }
  ];
  return entries;
};

export default testingAreas;
